import { render, staticRenderFns } from "./articleSearch.vue?vue&type=template&id=6245c6ce"
import script from "./articleSearch.vue?vue&type=script&lang=js"
export * from "./articleSearch.vue?vue&type=script&lang=js"
import style0 from "./articleSearch.vue?vue&type=style&index=0&id=6245c6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports